import * as React from "react";
import Konva from "konva";
import { Text, Circle } from "react-konva";
import { Label } from "../types";

interface Props {
  data: Label;
  yMax: number;
  xMax: number;
  yMin: number;
  xMin: number;
  canvasWidth: number;
  canvasHeight: number;
  marginTopBottom: number;
  marginLeftRight: number;
}

const LabelComponent: React.FC<Props> = ({
  data,
  xMax,
  yMax,
  xMin,
  yMin,
  canvasWidth,
  canvasHeight,
  marginTopBottom,
  marginLeftRight,
}) => {
  // Ratio should scale to value less than height x width of Image
  const ratioY = canvasWidth / (yMax - yMin);
  const ratioX = canvasHeight / (xMax - xMin);

  const textSize = 1.15 * ratioX;
  /*
    (dataX - xMin) - Translation to remove unused space in image
    
    Mulitplying to get real pixel in our 500x500 image
  
    Plus 250 to move whole scaled image to center of canvas
  
    Minus size scaled widthImage/2 to get the center
    */

  const textWidth = data.Width * ratioX;

  const x =
    data.X * ratioX - xMin * ratioX + (canvasWidth - (xMax - xMin) * ratioX);
  const y =
    data.Y * ratioY - yMin * ratioY + (canvasHeight - (yMax - yMin) * ratioY);

  /*   const x =
    (data.X - xMin) * ratioX +
    canvasWidth / 2 -
    ((xMax - xMin) * ratioX) / 2 -
    seatWidth / 4;
  const y =
    (data.Y - yMin) * ratioY + canvasHeight / 2 - ((yMax - yMin) * ratioY) / 2;
 */
  return (
    <>
      <Text
        x={x}
        y={y}
        fontSize={textSize}
        text={data.Text}
        width={textWidth}
        verticalAlign="center"
        fill="white"
      />
    </>
  );
};

export default LabelComponent;
